export const excelExportDefaults = {
	groupBy: 'CUSTOMER_LOCATION',
	purchasesToInclude: 'IN_BASKET',
	exportContents: ['MFR_SUMMARY', 'CONTRACT_DETAILS', 'ITEM_DETAILS', 'SETTINGS', 'GLOSSARY'],
	highlightDirectDeal: false,
	identifyOvercharges: false,
	markComplete: true,
}

export const pdfExportDefaults = {
	purchasesToInclude: 'IN_BASKET',
	markComplete: false,
}
